import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a4b348a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "kt_header",
  class: /*#__PURE__*/_normalizeClass(['header align-items-stretch full-header'])
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center flex-grow-1 flex-lg-grow-0 web-logo" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "Logo",
      src: "/favicon.ico",
      class: "h-40px"
    })
  ])
], -1))
const _hoisted_3 = { class: "d-flex align-items-center justify-content-between flex-lg-grow-1" }
const _hoisted_4 = {
  class: "d-flex",
  id: "kt_header_menu_nav"
}
const _hoisted_5 = { class: "d-flex align-items-stretch flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTMenu = _resolveComponent("KTMenu")!
  const _component_TopMenuList = _resolveComponent("TopMenuList")!
  const _component_KTTopbar = _resolveComponent("KTTopbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{
        'container-fluid': _ctx.headerWidthFluid,
        'container-xxl': !_ctx.headerWidthFluid,
      }, "d-flex align-items-stretch justify-content-between"])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_KTMenu),
          _createVNode(_component_TopMenuList)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_KTTopbar)
        ])
      ])
    ], 2)
  ]))
}